module.exports = __webpack_public_path__ + "img/mind_skeleton_32.8f9a666f.png";